module.exports = __webpack_public_path__ + "static/12-a0e8a6a23cb1fbdbdd138834bf019487.png";